module.exports = __webpack_public_path__ + "img/9.565d64c9.jpg";